<script>
export default{
    name: "table-dampak-pelatihan",
    props: {

    },
    components: [],
    data() {
       

    },
    mounted(){

    },
    methods: {
    
    }
}
</script>

<template>
<div class="row mt-3 mb-2">
    <div class="col-6">
        <div class="card-title">
            Form Data Pelatihan
        </div>
    </div>
    <div class="col-6">
        <div class="d-flex justify-content-end">
            <!-- button Menu -->
        </div>
    </div>
</div>

<!-- Content Tabs -->
<div class="row">
    <div class="col-12">
        <p class="mb-3 font-size-14">
            Bagaimana penilaian Anda terhadap dampak dari pelatihan Kepemimpinan Pengawas bagi staf Anda
            dalam melaksanakan tugas dan jabatannya ?
        </p>

        <form>
            <table class="table table-stripped table-condensed">
                <thead class="greyTheme">
                    <tr>
                        <th class="text-center align-middle" style="width:5%;">No</th>
                        <th class="text-center align-middle">Pernyataan</th>
                        <th class="text-center align-middle" colspan="4">Jawaban</th>
                    </tr>
                </thead>
                <tbody class="greyTheme">
                    <tr class="headerRow">
                        <td colspan="30"><b>Produktivitas</b></td>
                    </tr>
                    <tr>
                        <td class="text-center">1</td>
                        <td>
                            Terdapat peningkatan produktivitas individu setelah mengikuti pelatihan
                        </td>
                        <td>
                            <label for="optionRowK1" class="radioGroup">
                                <input type="radio" id="optionRowK1" value="1" name="optionRowK" v-model="optionRowK" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowK2" class="radioGroup">
                                <input type="radio" id="optionRowK2" value="2" name="optionRowK" v-model="optionRowK" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowK3" class="radioGroup">
                                <input type="radio" id="optionRowK3" value="3" name="optionRowK" v-model="optionRowK" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowK4" class="radioGroup">
                                <input type="radio" id="optionRowK4" value="4" name="optionRowK" v-model="optionRowK" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">2</td>
                        <td>
                            Dapat berkontibusi lebih dalam peningkatan pelayanan kepada stakeholder
                        </td>
                        <td>
                            <label for="optionRowL1" class="radioGroup">
                                <input type="radio" id="optionRowL1" value="1" name="optionRowL" v-model="optionRowL" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowL2" class="radioGroup">
                                <input type="radio" id="optionRowL2" value="2" name="optionRowL" v-model="optionRowL" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowL3" class="radioGroup">
                                <input type="radio" id="optionRowL3" value="3" name="optionRowL" v-model="optionRowL" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowL4" class="radioGroup">
                                <input type="radio" id="optionRowL4" value="4" name="optionRowL" v-model="optionRowL" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr class="headerRow">
                        <td colspan="30"><b>Keberlanjutan Aksi Perubahan</b></td>
                    </tr>
                    <tr>
                        <td class="text-center">3</td>
                        <td>
                            Target Aksi Perubahan dalam jangka panjang tercapai
                        </td>
                        <td>
                            <label for="optionRowM1" class="radioGroup">
                                <input type="radio" id="optionRowM1" value="1" name="optionRowM" v-model="optionRowM" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowM2" class="radioGroup">
                                <input type="radio" id="optionRowM2" value="2" name="optionRowM" v-model="optionRowM" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowM3" class="radioGroup">
                                <input type="radio" id="optionRowM3" value="3" name="optionRowM" v-model="optionRowM" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowM4" class="radioGroup">
                                <input type="radio" id="optionRowM4" value="4" name="optionRowM" v-model="optionRowM" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">4</td>
                        <td>
                            Seluruh tujuan Aksi Perubahan dapat tercapai
                        </td>
                        <td>
                            <label for="optionRowN1" class="radioGroup">
                                <input type="radio" id="optionRowN1" value="1" name="optionRowN" v-model="optionRowN" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowN2" class="radioGroup">
                                <input type="radio" id="optionRowN2" value="2" name="optionRowN" v-model="optionRowN" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowN3" class="radioGroup">
                                <input type="radio" id="optionRowN3" value="3" name="optionRowN" v-model="optionRowN" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowN4" class="radioGroup">
                                <input type="radio" id="optionRowN4" value="4" name="optionRowN" v-model="optionRowN" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">5</td>
                        <td>
                            Manfaat Aksi Perubahan
                        </td>
                        <td>
                            <label for="optionRowO1" class="radioGroup">
                                <input type="radio" id="optionRowO1" value="1" name="optionRowO" v-model="optionRowO" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowO2" class="radioGroup">
                                <input type="radio" id="optionRowO2" value="2" name="optionRowO" v-model="optionRowO" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowO3" class="radioGroup">
                                <input type="radio" id="optionRowO3" value="3" name="optionRowO" v-model="optionRowO" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowO4" class="radioGroup">
                                <input type="radio" id="optionRowO4" value="4" name="optionRowO" v-model="optionRowO" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p class="mt-5 mb-2 font-size-14">
                Menurut Anda, bagaimana faktor berikut ini mendukung pelaksanaan aksi perubahan staf Anda ?
            </p>

            <table class="table table-stripped table-condensed mb-4">
                <thead class="greyTheme">
                    <tr>
                        <th class="text-center align-middle" style="width:5%;">No</th>
                        <th class="text-center align-middle">Pernyataan</th>
                        <th class="text-center align-middle" colspan="4">Jawaban</th>
                    </tr>
                </thead>
                <tbody class="greyTheme">
                    <tr>
                        <td class="text-center">6</td>
                        <td>
                            Terdapat dukungan dari Mentor
                        </td>
                        <td>
                            <label for="optionRowP1" class="radioGroup">
                                <input type="radio" id="optionRowP1" value="1" name="optionRowP" v-model="optionRowP" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowP2" class="radioGroup">
                                <input type="radio" id="optionRowP2" value="2" name="optionRowP" v-model="optionRowP" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowP3" class="radioGroup">
                                <input type="radio" id="optionRowP3" value="3" name="optionRowP" v-model="optionRowP" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowP4" class="radioGroup">
                                <input type="radio" id="optionRowP4" value="4" name="optionRowP" v-model="optionRowP" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">7</td>
                        <td>
                            Terdapat dukungan Pemangku Kepentingan
                        </td>
                        <td>
                            <label for="optionRowQ1" class="radioGroup">
                                <input type="radio" id="optionRowQ1" value="1" name="optionRowQ" v-model="optionRowQ" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowQ2" class="radioGroup">
                                <input type="radio" id="optionRowQ2" value="2" name="optionRowQ" v-model="optionRowQ" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowQ3" class="radioGroup">
                                <input type="radio" id="optionRowQ3" value="3" name="optionRowQ" v-model="optionRowQ" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowQ4" class="radioGroup">
                                <input type="radio" id="optionRowQ4" value="4" name="optionRowQ" v-model="optionRowQ" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">8</td>
                        <td>
                            Terdapat dukungan dari Anggota Tim
                        </td>
                        <td>
                            <label for="optionRowR1" class="radioGroup">
                                <input type="radio" id="optionRowR1" value="1" name="optionRowR" v-model="optionRowR" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowR2" class="radioGroup">
                                <input type="radio" id="optionRowR2" value="2" name="optionRowR" v-model="optionRowR" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowR3" class="radioGroup">
                                <input type="radio" id="optionRowR3" value="3" name="optionRowR" v-model="optionRowR" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowR4" class="radioGroup">
                                <input type="radio" id="optionRowR4" value="4" name="optionRowR" v-model="optionRowR" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">9</td>
                        <td>
                            Terdapat dukungan Sarana dan Prasarana
                        </td>
                        <td>
                            <label for="optionRowS1" class="radioGroup">
                                <input type="radio" id="optionRowS1" value="1" name="optionRowS" v-model="optionRowS" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowS2" class="radioGroup">
                                <input type="radio" id="optionRowS2" value="2" name="optionRowS" v-model="optionRowS" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowS3" class="radioGroup">
                                <input type="radio" id="optionRowS3" value="3" name="optionRowS" v-model="optionRowS" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowS4" class="radioGroup">
                                <input type="radio" id="optionRowS4" value="4" name="optionRowS" v-model="optionRowS" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">10</td>
                        <td>
                            Dijadikan kegiatan rutin dalam menunjang tugas dan fungsi
                        </td>
                        <td>
                            <label for="optionRowT1" class="radioGroup">
                                <input type="radio" id="optionRowT1" value="1" name="optionRowT" v-model="optionRowT" disabled>
                                <span>1</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowT2" class="radioGroup">
                                <input type="radio" id="optionRowT2" value="2" name="optionRowT" v-model="optionRowT" disabled>
                                <span>2</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowT3" class="radioGroup">
                                <input type="radio" id="optionRowT3" value="3" name="optionRowT" v-model="optionRowT" disabled>
                                <span>3</span>
                            </label>
                        </td>
                        <td>
                            <label for="optionRowT4" class="radioGroup">
                                <input type="radio" id="optionRowT4" value="4" name="optionRowT" v-model="optionRowT" disabled>
                                <span>4</span>
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class="table table-borderless">
                <tbody>
                    <tr>
                        <td class="text-center" style="width:5%;">11</td>
                        <td>
                            Sebutkan faktor pendukung pelaksanaan aksi perubahan yang lain, jika ada ?
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <b-form-textarea id="myTextarea" v-model="myTextarea" placeholder="Tulis disini . . ." rows="3" max-rows="6" disabled></b-form-textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
</div>
</template>